module.exports = __webpack_public_path__ + "img/option-gray.5500749b.svg";